import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { UndergraduateDegreeTypes, PostgraduateDegreeTypes } from 'types';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export const educationOptions = [
	...new Set(
		[
			Object.values(UndergraduateDegreeTypes),
			Object.values(PostgraduateDegreeTypes),
		].flat()
	),
];

export const educationOptionsData = educationOptions
	?.map(degree => ({
		label: degree,
		value: degree,
	}))
	// .filter(e => e?.value !== 'Others');

const EducationFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const education = JSON.parse(searchParams.get('education') || '[]');
	const options = educationOptionsData;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!education?.length}
					placeholder={'Education'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, index) => (
								<Button
									key={index}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: education?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (education?.includes(option?.value?.toString())) {
											searchParams.set(
												'education',
												JSON.stringify(education?.filter((skill: string) => skill !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('education', JSON.stringify([...education, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									{option?.label}
									{education?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Education</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="B.Tech"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => education?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('education', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default EducationFilterInput;
